const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement('script')
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
}

document.addEventListener('alpine:init', () => {
  let products = []
  Alpine.data('ProductColorSelector', () => ({
    $section: null,
    $productCard: null,
    $productForm: null,
    $variantId: null,
    product: null,

    mounted() {
      let am = this
      am.$section = am.$el
      am.$productForm = am.$section.querySelector('product-form form')
      am.$variantId = am.$productForm.querySelector('[name="id"]')
      am.$productCard = am.$section.closest('.product-card-wrapper')
      am.SetProduct()
    },

    SetProduct() {
      let am = this
      UTILS.ConvertStringToJS(am.$section.querySelector('[data-product-json]').innerHTML)
      product.color_option = product.options_with_values.find((option) => option.name == 'Color')
      am.product = product
      products.push(product)
    },

    GetSelectedVariant() {
      let am = this
      const colorInput = am.$section.querySelector('input[name^="Color-"]:checked')
      if (!colorInput) return null

      return am.product.variants.find(
        (v) => v[`option${am.product.color_option.position}`] === colorInput.value
      )
    },

    e_ShowColorImage() {
      let am = this
      let variant = am.GetSelectedVariant()
      if (!variant?.media) return

      let $image
      if (window.matchMedia('(hover: none)').matches) {
        $image = am.$productCard.querySelector('.card__media img:first-of-type')
      } else {
        $image = am.$productCard.querySelector('.card__media img:last-of-type')
      }

      if (!$image) return

      $image.setAttribute('src', variant.media.src)
      $image.setAttribute('srcset', `${variant.media.src}?width=533`)
    },

    e_UpdateAvailableSizes(e) {
      let am = this
      let variant = am.GetSelectedVariant()
      if (variant && am.$variantId) {
        am.$variantId.value = variant.id
      }
    },
  }))

  Alpine.data('ProductQuickAdd', () => ({
    $section: null,
    $productCard: null,
    $productForm: null,
    hideSizes: true,
    product: null,

    mounted() {
      this.$section = this.$el
      this.$productCard = this.$section.closest('.product-card-wrapper')
      this.$productForm = this.$productCard.querySelector('product-form form')
      this.SetProduct()
      this.initializeUI()
    },

    initializeUI() {
      this.$section
        .querySelectorAll('.x-cloak-hidden')
        .forEach((item) => item.classList.remove('x-cloak-hidden'))

      document.addEventListener('cart:addtocart_complete', () => this.ToggleSizes(false))
    },

    SetProduct() {
      UTILS.ConvertStringToJS(this.$productCard.querySelector('[data-product-json]').innerHTML)
      this.product = {
        ...product,
        color_option: product.options_with_values.find((option) => option.name === 'Color'),
        first_non_color_option: product.options_with_values.find(
          (option) => option.name !== 'Color'
        ),
      }
    },

    ToggleSizes(toggle) {
      this.hideSizes = !toggle
    },

    e_ToggleSizes(e, toggle) {
      if (
        this.product.variants.length === 1 ||
        (this.product.color_option && !this.product.first_non_color_option)
      ) {
        this.$productForm.dispatchEvent(new Event('submit'))
        return
      }
      this.ToggleSizes(toggle)
    },

    e_QuickAddToCart(optionValue) {
      const $quickadd_main = this.$productCard.querySelector('.quick-add-color-selector')
      const $variantId = $quickadd_main.querySelector('.product-variant-id')
      const colorInput = $quickadd_main.querySelector('input[name^="Color-"]:checked')

      const variant = this.findMatchingVariant(colorInput?.value, optionValue)

      if (variant && $variantId) {
        $variantId.value = variant.id
        this.$productForm.dispatchEvent(new Event('submit', { bubbles: true }))
        this.ToggleSizes(false)
      }
    },

    findMatchingVariant(colorValue, optionValue) {
      return this.product.variants.find((v) => {
        const matchesColor =
          !colorValue || v[`option${this.product.color_option?.position}`] === colorValue
        const matchesOption =
          v[`option${this.product.first_non_color_option?.position}`] === optionValue
        return matchesColor && matchesOption
      })
    },
  }))
})
